import { useEffect, useState } from 'react';
import { BookOpen, ChevronRight } from 'lucide-react';
import ModalShell from '../ui/ModalShell';
import { BARVA_BG, BARVA_BORDER, TYPY, api, otevriZnalost, barva as barvaZnalosti } from './znalosti';

/**
 * Kolik publikovaných článků Znalostí má který objekt — jedním dotazem pro
 * celý seznam (kroky receptu): `{ [id]: počet }`.
 */
export function usePoctyZnalosti(typ, ids) {
    const [pocty, setPocty] = useState({});
    const otisk = (ids || []).filter(Boolean).join(',');
    useEffect(() => {
        if (!otisk) { setPocty({}); return; }
        let zruseno = false;
        api(`/api/znalosti/pocty?typ=${typ}&ids=${otisk}`).then(d => { if (!zruseno) setPocty(d || {}); }).catch(() => {});
        return () => { zruseno = true; };
    }, [typ, otisk]);
    return pocty;
}

/**
 * Ikonka „N jednobodovek" u kroku SOP (a dalších objektů). Jeden článek
 * otevře rovnou, víc nabídne v seznamu. Bez článků se nekreslí.
 */
export default function ZnalostiOdznak({ typ, id, pocet, isDark, kompaktni = false }) {
    const akcent = barvaZnalosti(isDark);
    const muted = isDark ? 'rgba(255,255,255,0.55)' : 'var(--text-secondary)';
    const cara = isDark ? 'rgba(255,255,255,0.10)' : 'var(--border-default)';
    const [seznam, setSeznam] = useState(null);

    if (!pocet) return null;

    const klik = async (e) => {
        e.stopPropagation();
        const d = await api(`/api/znalosti/k-objektu?typ=${typ}&id=${id}`).catch(() => null);
        const clanky = d?.clanky || [];
        if (clanky.length === 1) otevriZnalost({ clanek: clanky[0].id });
        else if (clanky.length > 1) setSeznam(clanky);
    };

    const popis = pocet === 1 ? 'jednobodovka' : pocet < 5 ? 'jednobodovky' : 'jednobodovek';
    return (
        <>
            <button type="button" onClick={klik} title="Otevřít ve Znalostech" aria-label={`${pocet} ${popis} ke kroku`}
                className="inline-flex items-center"
                style={{ gap: 5, height: kompaktni ? 24 : 28, padding: kompaktni ? '0 8px' : '0 10px', borderRadius: 999, fontSize: kompaktni ? 11 : 12, fontWeight: 700, cursor: 'pointer', color: akcent, background: BARVA_BG, border: `1px solid ${BARVA_BORDER}`, flexShrink: 0 }}>
                <BookOpen size={kompaktni ? 12 : 13} /> {pocet} {popis}
            </button>
            {seznam && (
                <ModalShell onClose={() => setSeznam(null)} isDark={isDark} nadpis="Jak na to" ikona={BookOpen} barva={akcent}>
                    <div style={{ padding: '0 2px 8px' }}>
                        {seznam.map(c => (
                            <button key={c.id} type="button" onClick={() => { setSeznam(null); otevriZnalost({ clanek: c.id }); }} className="w-full text-left flex items-center"
                                style={{ gap: 12, minHeight: 56, padding: '10px 12px', marginBottom: 8, borderRadius: 12, cursor: 'pointer', background: isDark ? 'rgba(255,255,255,0.05)' : 'rgba(0,0,0,0.025)', border: `1px solid ${cara}` }}>
                                <BookOpen size={18} style={{ color: akcent, flexShrink: 0 }} />
                                <span className="flex-1 min-w-0">
                                    <span className="block truncate" style={{ fontSize: 14.5, fontWeight: 650, color: 'var(--text-primary)' }}>{c.nazev}</span>
                                    <span className="block" style={{ fontSize: 12, color: muted }}>{TYPY[c.typ].label}{c.pocet_kroku ? ` · ${c.pocet_kroku} kroků` : ''}</span>
                                </span>
                                <ChevronRight size={18} style={{ color: muted }} />
                            </button>
                        ))}
                    </div>
                </ModalShell>
            )}
        </>
    );
}
